export default {
  DEFAULT: 'index',
  ONLINE_STORE: 'index-with-online-store',
};
